import { HealthCasesFilters } from './types';

import { HealthCase } from '@/api/healthCases';
import { DEFAULT_PER_PAGE } from '@/shared/constants';

export const INITIAL_FILTERS: HealthCasesFilters = {
  phrase: '',
  startPage: 0,
  perPage: DEFAULT_PER_PAGE,
  date: [undefined, undefined],
};

export const INITIAL_HEALTH_CASE: HealthCase = {
  id: '',
  name: '',
  caseDate: '',
  objectCount: 0,
  description: '',
};
